(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ColorPicker", [], factory);
	else if(typeof exports === 'object')
		exports["ColorPicker"] = factory();
	else
		root["ColorPicker"] = factory();
})(this, function() {
return 